"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledUploadWrapper = exports.StyledUploadUploadingText = exports.StyledUploadText = exports.StyledUploadRemoveIcon = exports.StyledUploadPictureCardWrapper = exports.StyledUploadListItemThumbnailIcon = exports.StyledUploadListItemThumbnail = exports.StyledUploadListItemProgress = exports.StyledUploadListItemNameSpan = exports.StyledUploadListItemNameA = exports.StyledUploadListItemInfo = exports.StyledUploadListItemIcon = exports.StyledUploadListItemActions = exports.StyledUploadListItem = exports.StyledUploadListContainer = exports.StyledUploadList = exports.StyledUploadLink = exports.StyledUploadIcon = exports.StyledUploadDragInfo = exports.StyledUploadDragContainer = exports.StyledUploadDocTypeIcon = exports.StyledUploadButtonContainer = exports.StyledUpload = exports.RightListWrapper = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _StyledButton = require("../Button/StyledButton");
var _Icon = _interopRequireDefault(require("../Icon"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _excluded = ["children", "className", "prefixCls", "listType"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledContainer = function StyledContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    prefixCls = _ref.prefixCls;
  var prefix = prefixCls ? prefixCls : className;
  return children(prefix);
};
var StyledFilteredContainer = function StyledFilteredContainer(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    prefixCls = _ref2.prefixCls,
    listType = _ref2.listType,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(StyledUploadList, (0, _extends2.default)({
    prefixCls: prefix,
    $listType: listType
  }, rest), children(prefix));
};
var StyledUploadPictureCardWrapper = exports.StyledUploadPictureCardWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-6cosim-0"
})(["", ";display:inline-block;width:100%;"], function (props) {
  return props.theme.mixins.clearFix(_ykbStyledComponents.css);
});
var RightListWrapper = exports.RightListWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-6cosim-1"
})(["", ""], function (props) {
  return (props.$listType == 'right-list-2' || props.$listType == 'right-list-3') && (0, _ykbStyledComponents.css)([".ykb-upload{display:flex;flex-wrap:wrap;gap:10px;overflow-x:auto;max-height:", ";.ykb-upload-list-item{flex-basis:", ";max-width:", ";height:40px;}.ykb-upload-list-item-info{display:flex;align-items:center;}}"], function (props) {
    return props.$heightUpload || props.theme.upload.multipleUpload.height;
  }, function (props) {
    return props.$listType == 'right-list-2' ? 'calc(50% - 10px)' : 'calc(33.33% - 10px)';
  }, function (props) {
    return props.$listType == 'right-list-2' ? 'calc(50% - 10px)' : 'calc(33.33% - 10px)';
  });
});
var StyledUploadIcon = exports.StyledUploadIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-6cosim-2"
})([""]);
var StyledUploadText = exports.StyledUploadText = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-6cosim-3"
})([""]);
var StyledUploadLink = exports.StyledUploadLink = (0, _ykbStyledComponents.default)(_StyledButton.Link).withConfig({
  componentId: "ykb-ui__sc-6cosim-4"
})([""]);
var StyledUploadDragInfo = exports.StyledUploadDragInfo = _ykbStyledComponents.default.p.withConfig({
  componentId: "ykb-ui__sc-6cosim-5"
})([""]);
var StyledUploadWrapper = exports.StyledUploadWrapper = (0, _ykbStyledComponents.default)(StyledContainer).withConfig({
  componentId: "ykb-ui__sc-6cosim-6"
})([""]);
var StyledUploadDocTypeIcon = exports.StyledUploadDocTypeIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-6cosim-7"
})([""]);
var StyledUploadRemoveIcon = exports.StyledUploadRemoveIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-6cosim-8"
})([""]);
var StyledUploadDragContainer = exports.StyledUploadDragContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-6cosim-9"
})(["", ""], function (props) {
  return (props.$listType == 'right-list' || props.$listType == 'right-list-2' || props.$listType == 'right-list-3') && (0, _ykbStyledComponents.css)(["display:flex;align-items:center;justify-content:center;flex-basis:50%;"]);
});
var StyledUploadListItemNameA = exports.StyledUploadListItemNameA = _ykbStyledComponents.default.a.withConfig({
  componentId: "ykb-ui__sc-6cosim-10"
})([""]);
var StyledUploadListItemNameSpan = exports.StyledUploadListItemNameSpan = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-6cosim-11"
})([""]);
var StyledUploadListItemInfo = exports.StyledUploadListItemInfo = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-6cosim-12"
})(["height:100%;padding:", " ", " ", " calc(", " / 2);transition:background-color 0.3s;color:", ";> span{display:block;}", ",", "{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-left:calc(", " + 4px);width:100%;display:inline-block;vertical-align:middle;}", "{font-size:", ";color:", ";position:absolute;top:50%;transform:translateY(-50%);}"], function (props) {
  return props.theme.component.padding;
}, function (props) {
  return props.theme.icon.size.medium.fontSize;
}, function (props) {
  return props.theme.component.padding;
}, function (props) {
  return props.theme.component.padding;
}, function (props) {
  return props.theme.text.color;
}, StyledUploadListItemNameA, StyledUploadListItemNameSpan, function (props) {
  return props.theme.upload.listItemIconSize;
}, StyledUploadDocTypeIcon, function (props) {
  return props.theme.upload.listItemIconSize;
}, function (props) {
  return props.theme.icon.type.primary.color;
});
var StyledUploadListItem = exports.StyledUploadListItem = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-6cosim-13"
})(["border:", " ", " ", ";font-size:", ";position:relative;border-radius:", ";margin-top:5px;", " &:last-child{border-bottom:", " ", " ", ";margin-bottom:5px;}", "{font-size:", ";transition:all 0.3s;opacity:0;cursor:pointer;position:absolute;top:50%;transform:translateY(-50%);right:4px;color:", ";&:hover{color:", ";}}&:hover{", "{background-color:", ";}", "{opacity:1;}}", ""], function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.border.style;
}, function (props) {
  return props.theme.border.colorBase;
}, function (props) {
  return props.theme.font.size;
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.$listType == 'right-list' && (0, _ykbStyledComponents.css)(["&:first-child{margin-top:0 !important;}"]);
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.border.style;
}, function (props) {
  return props.theme.border.colorBase;
}, StyledUploadRemoveIcon, function (props) {
  return props.theme.upload.listItemIconSize;
}, function (props) {
  return props.theme.icon.type.primary.color;
}, function (props) {
  return props.theme.icon.type.primary.hoverColor;
}, StyledUploadListItemInfo, function (props) {
  return props.theme.color.primary1;
}, StyledUploadRemoveIcon, function (props) {
  return props.$status == 'error' && (0, _ykbStyledComponents.css)(["color:", ";border-color:", " !important;", ",[class$='-name']{color:", ";}", "{opacity:1;color:", " !important;}", "{color:", " !important;}"], function (props) {
    return props.theme.upload.errorColor;
  }, function (props) {
    return props.theme.upload.errorColor;
  }, StyledUploadDocTypeIcon, function (props) {
    return props.theme.upload.errorColor;
  }, StyledUploadRemoveIcon, function (props) {
    return props.theme.upload.errorColor;
  }, StyledUploadListItemNameSpan, function (props) {
    return props.theme.upload.errorColor;
  });
});
var StyledUploadListItemThumbnailIcon = exports.StyledUploadListItemThumbnailIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-6cosim-14"
})([""]);
var StyledUploadListItemThumbnail = exports.StyledUploadListItemThumbnail = _ykbStyledComponents.default.a.withConfig({
  componentId: "ykb-ui__sc-6cosim-15"
})([""]);
var StyledUploadList = exports.StyledUploadList = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-6cosim-16"
})(["", " .", "{&-item-list-type-text{&:hover{[class*='-list-item-name-icon-count-1']{padding-right:14px;}[class*='-list-item-name-icon-count-2']{padding-right:28px;}}}", " [class$='-success-icon']{color:", ";font-weight:bold;}&-animate-enter,&-animate-leave,&-animate-inline-enter,&-animate-inline-leave{animation-duration:0.3s;animation-fill-mode:", ";}&-animate-enter{animation-name:", ";}&-animate-leave{animation-name:", ";}&-animate-inline-enter{animation-name:", ";}&-animate-inline-leave{animation-name:", ";}}"], function (props) {
  return (props.$listType == 'right-list' || props.$listType == 'right-list-2' || props.$listType == 'right-list-3') && (0, _ykbStyledComponents.css)(["flex-basis:50%;margin-left:16px;overflow-y:auto;"]);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return (props.$listType == 'picture' || props.$listType == 'picture-card') && (0, _ykbStyledComponents.css)(["", "{position:relative;height:66px;padding:8px;border:", " ", " ", ";border-radius:", ";&:hover{background:transparent;", "{background:transparent;}}", " [class*='-image']{max-width:100%;}}", "{padding:0;}", " ", ",", "{position:absolute;top:8px;left:8px;width:48px;height:48px;font-size:26px;line-height:54px;text-align:center;opacity:0.8;img{display:block;width:48px;height:48px;overflow:hidden;}}", "{position:absolute;top:50%;left:50%;font-size:26px;transform:translate(-50%,-50%);}", ",", "{display:inline-block;box-sizing:border-box;max-width:100%;margin:0 0 0 8px;padding-right:8px;padding-left:48px;overflow:hidden;line-height:44px;white-space:nowrap;text-overflow:ellipsis;transition:all 0.3s;}[class*='-list-item-name-icon-count-1']{padding-right:18px;}[class*='-list-item-name-icon-count-2']{padding-right:36px;}", "{bottom:14px;width:calc(100% - 24px);margin-top:0;padding-left:56px;}", "{position:absolute;top:50%;left:50%;z-index:10;white-space:nowrap;transform:translate(-50%,-50%);opacity:0;transition:all 0.3s;}", ":hover + ", ",", ":hover{opacity:1;}[class*='anticon-picture'] + ", ",[class*='anticon-picture'] + ", "{position:absolute;bottom:10px;display:block;}", ""], StyledUploadListItem, function (props) {
    return props.theme.border.width;
  }, function (props) {
    return props.theme.upload.pictureCardBorderStyle;
  }, function (props) {
    return props.theme.border.colorBase;
  }, function (props) {
    return props.theme.borderRadiusBase;
  }, StyledUploadListItemInfo, function (props) {
    return props.$status == 'error' && (0, _ykbStyledComponents.css)(["border-color:", ";"], function (props) {
      return props.theme.upload.errorColor;
    });
  }, StyledUploadListItemInfo, function (props) {
    return props.$status == 'uploading' && (0, _ykbStyledComponents.css)(["border-style:dashed;", ",", "{line-height:28px;}"], StyledUploadListItemNameA, StyledUploadListItemNameSpan);
  }, StyledUploadListItemThumbnail, StyledUploadListItemThumbnailIcon, StyledUploadListItemIcon, StyledUploadListItemNameA, StyledUploadListItemNameSpan, StyledUploadListItemProgress, StyledUploadListItemActions, StyledUploadListItemInfo, StyledUploadListItemActions, StyledUploadListItemActions, StyledUploadListItemNameA, StyledUploadListItemNameSpan, function (props) {
    return props.$status == 'uploading' && (0, _ykbStyledComponents.css)(["&", "{background-color:", ";}", "{height:auto;}", "{margin-top:18px;color:", ";}"], StyledUploadListItem, function (props) {
      return props.theme.upload.backgroundColor;
    }, StyledUploadListItemInfo, StyledUploadUploadingText, function (props) {
      return props.theme.text.color;
    });
  });
}, function (props) {
  return props.theme.upload.successColor;
}, function (props) {
  return props.theme.animation.ease.inOutCirc;
}, uploadAnimateIn, uploadAnimateOut, uploadAnimateInlineIn, uploadAnimateInlineOut);
var StyledUploadListContainer = exports.StyledUploadListContainer = (0, _ykbStyledComponents.default)(StyledFilteredContainer).withConfig({
  componentId: "ykb-ui__sc-6cosim-17"
})([""]);
var StyledUploadListItemProgress = exports.StyledUploadListItemProgress = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-6cosim-18"
})(["line-height:0;font-size:", ";position:absolute;width:100%;bottom:5px;padding-left:calc(", " + 10px);padding-right:8px;height:7px;"], function (props) {
  return props.theme.font.size;
}, function (props) {
  return props.theme.font.size;
});
var StyledUploadListItemIcon = exports.StyledUploadListItemIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-6cosim-19"
})([""]);
var StyledUploadListItemActions = exports.StyledUploadListItemActions = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-6cosim-20"
})([""]);
var StyledUploadUploadingText = exports.StyledUploadUploadingText = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-6cosim-21"
})([""]);
var uploadAnimateIn = (0, _ykbStyledComponents.keyframes)(["from{height:0;margin:0;opacity:0;padding:0;}"]);
var uploadAnimateOut = (0, _ykbStyledComponents.keyframes)(["to{height:0;margin:0;padding:0;opacity:0;}"]);
var uploadAnimateInlineIn = (0, _ykbStyledComponents.keyframes)(["from{width:0;height:0;margin:0;opacity:0;padding:0;}"]);
var uploadAnimateInlineOut = (0, _ykbStyledComponents.keyframes)(["to{width:0;height:0;margin:0;padding:0;opacity:0;}"]);
var StyledUpload = exports.StyledUpload = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-6cosim-22"
})(["outline:0;p{margin:0;}input[type='file']{cursor:pointer;}.", "-btn{display:block;width:100%;outline:none;}", " &&-select-picture-card{display:table;float:left;width:", ";height:", ";margin-right:8px;margin-bottom:8px;text-align:center;vertical-align:top;background-color:", ";border:", " dashed ", ";border-radius:", ";cursor:pointer;transition:border-color 0.3s ease;> ", "{display:table-cell;width:100%;height:100%;padding:8px;text-align:center;vertical-align:middle;}&:hover{border-color:", ";}}&[class*='-drag']{border:", " dashed ", ";transition:border-color 0.3s;cursor:pointer;border-radius:", ";text-align:center;width:100%;height:100%;position:relative;padding:", ";", " ", " ", " .", "-btn{display:table;height:100%;width:100%;}", "{display:table-cell;vertical-align:middle;", "{margin:0px;", "{color:", ";font-size:", ";display:inline-block;vertical-align:middle;margin-right:5px;&:hover{color:", ";}}}}p[class$='-drag-icon']{", "{font-size:48px;color:", ";}margin-bottom:20px;}p[class$='-text']{font-size:", ";margin:0 0 4px;color:", ";}p[class$='-hint']{font-size:", ";color:", ";}[class$='-plus']{font-size:30px;transition:all 0.3s;color:", ";&:hover{color:", ";}}&:hover{[class$='-plus']{color:", ";}}}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.$disabled && (0, _ykbStyledComponents.css)(["cursor:not-allowed;"]);
}, function (props) {
  return props.theme.upload.pictureCardSize;
}, function (props) {
  return props.theme.upload.pictureCardSize;
}, function (props) {
  return props.theme.upload.backgroundColor;
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.border.colorBase;
}, function (props) {
  return props.theme.borderRadiusBase;
}, StyledUpload, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.border.colorBase;
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.component.padding;
}, function (props) {
  return (props.$listType == 'right-list' || props.$listType == 'right-list-2' || props.$listType == 'right-list-3') && (0, _ykbStyledComponents.css)(["display:flex;align-items:center;justify-content:center;flex-basis:50%;"]);
}, function (props) {
  return props.$hover && !props.$disabled && (0, _ykbStyledComponents.css)(["border:calc(", " * 2) dashed ", ";"], function (props) {
    return props.theme.border.width;
  }, function (props) {
    return props.theme.color.primary5;
  });
}, function (props) {
  return props.$disabled ? (0, _ykbStyledComponents.css)(["background-color:", ";cursor:not-allowed;", ",", ",", "{color:", ";&:hover{text-decoration:none;}}"], function (props) {
    return props.theme.input.disabled.backgroundColor;
  }, StyledUploadIcon, StyledUploadText, StyledUploadLink, function (props) {
    return props.theme.text.colorDisabled;
  }) : (0, _ykbStyledComponents.css)(["&:hover{border-color:", ";}"], function (props) {
    return props.theme.upload.infoColor;
  });
}, function (props) {
  return props.prefixCls;
}, StyledUploadDragContainer, StyledUploadDragInfo, StyledUploadIcon, function (props) {
  return props.theme.upload.linkColor;
}, function (props) {
  return props.theme.icon.size.medium.fontSize;
}, function (props) {
  return props.theme.upload.linkHoverColor;
}, StyledUploadIcon, function (props) {
  return props.theme.upload.infoColor;
}, function (props) {
  return props.theme.font.sizeLg;
}, function (props) {
  return props.theme.upload.headingColor;
}, function (props) {
  return props.theme.font.size;
}, function (props) {
  return props.theme.upload.infoColor;
}, function (props) {
  return props.theme.upload.disabledColor;
}, function (props) {
  return props.theme.upload.infoColor;
}, function (props) {
  return props.theme.upload.infoColor;
});
var StyledUploadButtonContainer = exports.StyledUploadButtonContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-6cosim-23"
})([""]);